import React, { useState } from 'react';
import { useStyles } from './styles';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { TextField } from '@material-ui/core';
import { authAPI } from 'src/api/modules/auth';
import notice from 'src/common/components/Notice';
import { onSaveDataTok } from './utils/save_data';
import { getAppParams } from 'src/utils/getAppParams';
import { getAllOrgans } from 'src/utils/getSubOrganos';
import { actions as menu } from 'src/redux/ducks/menu';
import { profilesAPI } from 'src/api/modules/profiles';
import { organsAction } from 'src/redux/ducks/organsByRole';
import FirstLogin from 'src/pages/Auth/Components/FirstLogin';
import { generateIv, encryptAES256 } from 'src/utils/getEncrypt';
import { actions as auth } from '../../../redux/ducks/auth.duck';
import { actions as organ } from 'src/redux/ducks/selectedCollegiateBody';
import { actions as changePassword } from '../../../redux/ducks/changePassword';
import { actions as passwordRequest } from '../../../redux/ducks/passwordRequest';

function LogPage(props) {
	let history = useHistory();
	const classes = useStyles();
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);
	const [fistLogin, setFistLogin] = useState(false);
	const [validation, setValidation] = useState(false);
	const [loginForm, setLoginForm] = useState({ usuario: '', pass: '' });
	const isDev = process.env.REACT_APP_ENVIRONMENT === 'DEV';
	const filial = localStorage.getItem('type');
	const notNeedOrgans = [
		'ADMINISTRADOR GENERAL',
		'SISTEMA',
		'RESPONSABLE DE NEGOCIO',
		'OPERADOR DE SEGURIDAD',
		'RESPONSABLE CASIA',
	];

	const handleChange = (e) => {
		const { name, value } = e.target;
		setLoginForm({ ...loginForm, [name]: value });
	};

	const onChangePassword = () => {
		dispatch(changePassword.SetChangePass(true));
	};
	const onPasswordRequest = () => {
		dispatch(changePassword.SetChangePass(0));
		dispatch(passwordRequest.SetPassRequest(true));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		let typeUser = loginForm.usuario.substr(0, 2);
		let user = loginForm.usuario.trim();

		if (!loginForm.usuario || !loginForm.pass)
			return notice('Complete los datos', 'info');

		setLoading(true);
		let organMenu;
		const iv = generateIv();

		// Convertir el IV a Base64
		const finalIV = iv; // Ya es Base64, no es necesario convertirlo a Hex

		// Encriptar la contraseña con AES
		const passEncrypt = encryptAES256(loginForm.pass, iv);
		const finalPass = passEncrypt.replaceAll('%2b', '+');
		const constructora = filial !== null ? 1 : 0;

		await authAPI
			.post({
				usuario: user,
				password: finalPass,
				iv: finalIV,
				constructora,
				isAPL0081: true,
			})
			.then((response) => {
				if (response.codigo === 'SAOC-02') {
					localStorage.setItem('firstLogin', loginForm.usuario);
					setFistLogin(true);
				} else if (response.codigo === 'SAOC-400') {
					notice(JSON.parse(JSON.stringify(response.mensaje)));
				} else if (
					response.nombrePerfil === '' ||
					response.nombrePerfil === undefined
				) {
					notice(
						'Datos de usuario incompletos, pedir a un adminstrador asignar un perfil.'
					);
					return false;
				} else if (
					response.organos.length === 0 &&
					notNeedOrgans.includes(response.nombrePerfil.toUpperCase()) === false
				) {
					notice(
						'Datos de usuario incompletos, pedir a un adminstrador asignar órganos colegiados'
					);
					return false;
				} else {
					let abc = response.password;
					delete response.password;

					// if (
					// 	notNeedOrgans.includes(response.nombrePerfil.toUpperCase()) ===
					// 	true
					// ) {
					// 	response.organos = [
					// 		{
					// 			perfilID: Number(response.id_perfil),
					// 			nombrePerfil: response.nombrePerfil,
					// 		},
					// 	];
					// }
					const dateExpired = response.fechaVencimientoToken;

					dispatch(
						auth.setUser({
							...response,
							abc,
						})
					);
					onSaveDataTok(dateExpired);

					dispatch(
						organsAction.setOrganosByRole(getAllOrgans(response.organos))
					);
					organMenu = response.organos[0];
					dispatch(organ.setOrgano(organMenu));

					profilesAPI
						.get(Number(response.id_perfil))
						.then((response) => {
							if (response.modulosAsignados.length > 0) {
								let items = [];

								response.modulosAsignados.forEach((module) => {
									module['title'] = module.nombre;
									delete module.nombre;
									items.push(module);
									let subModules = [];
									if (module.hijos?.length > 0) {
										module.hijos.forEach((subModule) => {
											subModules.push({
												id: subModule.id,
												display_text: subModule.nombre,
												slug: subModule.slug,
											});
										});
										return (module['submodules'] = subModules);
									}
								});

								items.sort((a, b) => a.id - b.id);

								let aside = {
									aside: {
										items: items,
									},
								};

								dispatch(menu.setMenu(aside));
							}
						})
						.catch(() => notice('Ocurrio un error', 'error'));

					getAppParams('UMN'); //Obetener usuario minosNet
					getAppParams('X_APP_KEY'); //Obetener header para servicios minosNet

					if (localStorage.getItem('redirectSession')) {
						const redirectPath = localStorage.getItem('redirectSession');
						localStorage.removeItem('redirectSession');
						history.push(redirectPath);
					}
				}
			})
			.catch((e) => {
				if (isDev) {
					if (e?.response?.data?.mensaje === undefined) {
						notice('Ha ocurrido un error con su petición');
					} else notice(JSON.parse(JSON.stringify(e?.response?.data?.mensaje)));
				} else notice('Ha ocurrido un error con su petición');

				return false;
			})
			.finally(() => {
				setLoading(false);

				if (typeUser.toLowerCase() === 'is') {
					setValidation(true);
				} else {
					setValidation(false);
				}
			});
	};

	return (
		<div
			className={`login-form login-signin ${classes.containerForm}`}
			id="kt_login_signin_form"
		>
			<div className="mb-10 mb-lg-10"></div>
			{/* end::Head */}
			{/*begin::Form*/}
			<div className="text-center mb-lg-3">
				<span>Ingrese Usuario con IN o IS</span>
			</div>

			<form
				onSubmit={handleSubmit}
				className="form fv-plugins-bootstrap fv-plugins-framework"
				onKeyDown={(e) => e.key === 'Enter' && handleSubmit(e)}
			>
				<div className={classes.containerForm}>
					<TextField
						id="usuario"
						name="usuario"
						className={classes.textField}
						label="Usuario"
						variant="outlined"
						onChange={handleChange}
					/>
					<TextField
						id="password"
						name="pass"
						label="Contraseña"
						type="password"
						className={classes.textField}
						variant="outlined"
						onChange={handleChange}
					/>
					{loginForm.usuario.toLowerCase().search('is') > -1 && (
						<div>
							<label style={{ textAlign: 'center' }}>
								<b>
									Si es la primera vez que ingresa a SAOC, deberá
									ingresar con la contraseña proporcionada mediante
									correo electrónico.
								</b>
							</label>
						</div>
					)}
					<div className="text-center">
						<button
							id="kt_login_signin_submit"
							type="submit"
							disabled={loading}
							className={`btn btn-danger font-weight-bold px-9 py-4 my-3 rounded-lg w-100`}
							data-testid="button-login"
						>
							<span>Iniciar Sesión</span>
							{loading && (
								<span className="ml-3 spinner spinner-white"></span>
							)}
						</button>
					</div>
					<div className="text-center">
						{validation === true ? (
							<Link onClick={onPasswordRequest}>
								¿Has olvidado la contraseña?
							</Link>
						) : (
							''
						)}
					</div>
					<FirstLogin
						open={fistLogin}
						setOpen={setFistLogin}
						onConfirm={onChangePassword}
					/>
				</div>
			</form>
			{/*end::Form*/}
		</div>
	);
}

export default LogPage;
